import React, { useEffect, useState } from 'react'
import { Button, Table, Typography, Space, Image, Select, Row, Col, Flex, Form, Switch, Avatar } from 'antd'
import { ActionButton, AddJobDrawer, AlertModal, JobViewModal, SearchInput } from '../..';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';
import moment from 'moment';

let timer;
const { Text } = Typography;
const JobTable = ({setVisible, visible}) => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)
    const [ view, setView ] = useState(null)
    const [ viewmodal, setViewModal] = useState(false)
    const [ edititem, setEditItem ] = useState(null)
    const [form] = Form.useForm();
    const [ deletionLoading, setDeletionLoading]= useState(false)
    const dispatch = useDispatch()
    const { jobData, loadingjob, filters, pagination } = useSelector(state => state?.Jobgetapi)
    

    useEffect(() => {
        dispatch(actionsApi?.getJobApi({ ...filters, ...pagination, pageNo: 1 }))
        form.setFieldsValue({
            ...filters,
        })
    }, [])
    
    const call = (pageNo = 1, pageSize = 10) => {
        dispatch(actionsApi?.getJobApi({ ...filters, pageNo, pageSize }))
    }

    function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getJobApi({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)

    const onChange = (checked, row) => {
        const newStatus = checked ? 1 : 2;
        dispatch(actionsApi?.jobstatusResponse({ id: row.id, status: newStatus }));
        dispatch(actionsApi?.updateJobStatus({ id: row.id, status: newStatus }));
    };

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Image</Text>,
            dataIndex: 'image',
            width:'150px',
            render:(_,row) => (
                <Avatar 
                    size={55}
                    src={<Image src={row.image} width={60} height={60} style={{objectFit:'cover'}} preview={false}/>}
                />
            ),
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Services</Text>,
            dataIndex: 'service',
            render: (service) => `${service.name}`
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>OrganizatioN Name</Text>,
            dataIndex: 'organizationName'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Budget</Text>,
            dataIndex: 'budget'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                return (
                    status === 1 ? (
                        <Text className='active fs-12 badge-cs'>Active</Text>
                    ) : (
                        <Text className='inactive fs-12 badge-cs'>Inactive</Text>
                    )
                );
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date',
            render: (date) => (
                <Text>
                    {
                        moment(date).format('YYYY-MM-DD')
                    }
                </Text>
            )
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 200,
            render: (_, row) => (
                <Space>
                    <Switch size='small' defaultChecked 
                        checked={row?.status === 1}
                        onChange={(checked) => onChange(checked, row)}
                    />
                    <ActionButton
                        title='View Job'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setViewModal(true);setView({...row,service:row?.service})}}
                    />
                    <ActionButton
                        title='Edit Job'
                        shape="circle"
                        icon={<Image src='/assets/icons/edit.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setVisible(true);setEditItem({...row,service:row?.service})}}
                    />
                    <ActionButton
                        title='Delete Job'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.service?.name, id: row?.id})}}
                    />
                </Space>
            ),
        },
    ];
    
    // delete job api
    const DeleteJob= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.addJobapi?.DeleteJob(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }

    return (
        <Flex vertical gap={20}>
            <Form
                form={form}
                layout="vertical"
            >
                <Row gutter={[16,16]} align={'middle'}>
                    <Col lg={8} md={12} sm={24} xs={24}>
                        <SearchInput 
                            name='name'
                            placeholder='Search job'
                            prefix={<img src='/assets/icons/search.png' width={20} />}
                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                            onChange={(e)=>debouncedSearchHandler(e.target.value, 1, 20)}
                        />
                    </Col>
                </Row>
            </Form>
            <Table
                size='large'
                columns={columns}
                dataSource={jobData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 1600 }}
                pagination={{
                    hideOnSinglePage: true,
                    total: pagination?.totalRecords,
                    pageSize: pagination?.pageSize,
                    defaultPageSize: pagination?.pageSize,
                    current: pagination?.pageNo,
                    size: "default",
                    pageSizeOptions: ['10', '20', '50', '100'],
                    onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                    showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                }}
                loading = {
                    {
                        ...TableLoader,
                        spinning: loadingjob
                    }
                }
            />
            <AddJobDrawer 
                visible={visible}
                edititem={edititem}
                getJobApi={call}
                onClose={()=>{setVisible(false);setEditItem(null)}}
            />
            <JobViewModal 
                visible={viewmodal}
                view={view}
                onClose={()=>{setViewModal(false);setView(null)}}
            />
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                callBack={DeleteJob}
                deletionLoading={deletionLoading}
                onClose={()=>{setDeleteItem(false)}}
            />
        </Flex>
    )
}

export { JobTable }